import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Box, Popover } from "@mui/material";
import ViewsMenu from "./ViewsMenu";
import { useTranslation } from "react-i18next";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { ViewsStyles } from "./ViewsStyles";
import {
  createNewView,
  deleteView,
  getDataViews,
  applyDataTableView,
  saveCurrentView,
} from "../../../../../../redux/actions/dataTable/DataSaveViewsAsyncActions";
import {
  setDeleteViewSuccessRested,
  setTableConfiguration,
} from "../../../../../../redux/slices/dataTable/dataViews";
import { resetDataTableState } from "../../../../../../redux/slices/dataTable/data";
import { resetDataTableFilters } from "../../../../../../redux/slices/dataTable/dataTableFilters";
import { dataTableActionNewFilter } from "../../../../../../redux/actions/dataTable/DataTableAsyncActions";
import { ButtonMenuDataTableProps } from "../export/ExportButton";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    getViews: () => {
      return dispatch(getDataViews());
    },
    setTableConfiguration: (config: any) => {
      dispatch(setTableConfiguration(config));
    },
    createNewView: () => {
      return dispatch(createNewView());
    },
    deleteView: (viewId: string) => {
      dispatch(deleteView(viewId));
    },

    resetTableView: () => {
      dispatch(resetDataTableState());
      dispatch(resetDataTableFilters());
      dispatch(dataTableActionNewFilter());
    },

    dataTableApplyView: (viewConfig: any) => {
      dispatch(resetDataTableFilters());
      dispatch(applyDataTableView(viewConfig));
    },

    setDeleteViewSuccessRested: () => {
      dispatch(setDeleteViewSuccessRested());
    },

    saveCurrentView: (viewData: {
      viewName: string;
      viewDescription: string;
      tableConfig: any;
      filtersConfig: any;
      dataDateActivityConfig: any;
      hasDateFilterChanged: boolean;
    }) => {
      return dispatch(
        saveCurrentView({
          viewName: viewData.viewName,
          viewDescription: viewData.viewDescription,
          tableConfig: viewData.tableConfig,
          filtersConfig: viewData.filtersConfig,
          dataDateActivityConfig: viewData.dataDateActivityConfig,
          hasDateFilterChanged: viewData.hasDateFilterChanged,
        })
      );
    },
  };
};

const Views: FC<ButtonMenuDataTableProps> = ({ loading, disabled = false }) => {
  const {
    getViews,
    setTableConfiguration,
    createNewView,
    resetTableView,
    deleteView,
    dataTableApplyView,
    saveCurrentView,
    setDeleteViewSuccessRested,
  } = SetActions();
  const { t } = useTranslation("global");

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    getViews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Button
        variant="outlined"
        startIcon={<VisibilityIcon />}
        onClick={handleOpenMenu}
        disabled={loading || disabled}
        sx={ViewsStyles.viewsButton}
      >
        {t("Data_views.saved_views")}
      </Button>

      <Popover
        open={isMenuOpen}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={ViewsStyles.popover}
      >
        <ViewsMenu
          t={t}
          setDeleteViewSuccessRested={setDeleteViewSuccessRested}
          onClose={handleCloseMenu}
          setTableConfiguration={setTableConfiguration}
          createNewView={createNewView}
          getViews={getViews}
          resetTableView={resetTableView}
          deleteView={deleteView}
          dataTableApplyView={dataTableApplyView}
          saveCurrentView={saveCurrentView}
        />
      </Popover>
    </Box>
  );
};

export default Views;
